export const experienceData = [
    {
        id: 1,
        company: 'Embibe',
        jobtitle: 'Software Engineer',
        startYear: 'Jan-2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Freshworks',
        jobtitle: 'Software Engineer- Frontend',
        startYear: 'Jan-2022 to Dec-2022',
        endYear: '2022'
    },
]
